import { useDispatch } from 'react-redux';
import { showSpinner, hideSpinner } from '../redux/slices/spinnerSlice';
import shapesAPI from '../services/shapesAPI';

export const useFetchWithSpinner = () => {
  const dispatch = useDispatch();

  const fetchWithSpinner = async (fetchParams, setData) => {
    try {
      dispatch(showSpinner());
      const response = await shapesAPI.fetchData(fetchParams);
      setData(response.data);
    } catch (error) {
      console.error('Error cargando datos:', error);
    } finally {
      dispatch(hideSpinner());
    }
  };

  return fetchWithSpinner;
};
